export const projectPaths = {
    list: () => 'admin/projects',
    detail: (id) => `admin/projects/${id}`,
    plans: () => 'admin/plans',
};
